"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } }/* Which team {{team_name}} names when a template goes into a chat: the team
 * the message goes out as. */













/* A plain SMS goes out as the team whose number sends it; the shared BloomText
 * number names no team. A secure or internal chat with one team is that team;
 * with several, the sender's own team in it if there's exactly one. Returns
 * null when no team can be named (the chip stays), or undefined when this
 * client doesn't hold what the SMS rule needs. */
 const templateTeamName = ({ channel, sendingNumber, chatTeamKeys, myTeamKeys, teamNames }) => {
  if (channel === 'sms') {
    if (sendingNumber.kind === 'team') return sendingNumber.team.Name
    return sendingNumber.kind === 'shared' ? null : undefined
  }
  const candidates = chatTeamKeys.length === 1 ? chatTeamKeys : chatTeamKeys.filter(key => myTeamKeys.includes(key))
  return candidates.length === 1 ? _nullishCoalesce(teamNames[candidates[0]], () => ( null)) : null
}; exports.templateTeamName = templateTeamName
